export class SourceMetadata {
  sourceId: number;
  geoTypes: string[];

  constructor(sourceId: number, geoTypes: string[]) {
    this.sourceId = sourceId;
    this.geoTypes = geoTypes;
  }
}